import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useDebounce from 'shared/hooks/useDebounce'
import { useCallback } from 'react'
import useItemsSetter from 'recoil/useItemsSetter'
import useTableWithRequest from 'shared/Table/useTableWithRequest'
import Table from 'shared/Table'
import organiaztionsTableAtom from './organizations.atom'
import organizationsApi from '../../organizations.api'
import { IOrganization } from '../../organizations.types'
import organiaztionsTableFields from './organizationsTable.fields'

const OrganiaztionsTable = () => {
  const navigate = useNavigate()
  const state = useRecoilValue(organiaztionsTableAtom)
  const debouncedSearch = useDebounce(state.filters.search, 400)

  const fetcher = useCallback(
    (params: Record<string, any>) => {
      return organizationsApi.list({
        search: debouncedSearch,
        ...params,
      })
    },
    [debouncedSearch]
  )

  const itemsSetter = useItemsSetter(organiaztionsTableAtom)

  const tableCtrl = useTableWithRequest({
    dataFetcher: fetcher,
    fields: organiaztionsTableFields,
    itemKey: 'id',
    items: state.items,
    setItems: itemsSetter,
    tableKey: 'organizations',
  })

  const handleClick = useCallback((organization: IOrganization) => {
    navigate(`/admin/organizations/${organization.id}`)
  }, [])

  return (
    <>
      <Table
        {...tableCtrl}
        items={tableCtrl.orderedItems}
        handleSelect={tableCtrl.selectedCtrl.setSelected}
        selected={tableCtrl.selectedCtrl.selectedIndexes as Set<keyof IOrganization>}
        handleSelectAll={tableCtrl.selectedCtrl.setSelectAll}
        itemKey='id'
        onCLick={handleClick}
      />
    </>
  )
}

export default OrganiaztionsTable
